import AccountOutlined from '../../src/legacy/AccountOutlined';
export default AccountOutlined;
